import {
  Box,
  Typography,
  Container,
  Stack,
  Link as MuiLink,
  Divider,
} from "@mui/material"
import { NavLink } from "react-router-dom"
import { menuItems } from "../../constants/menuItems"
import { useLocation } from "react-router-dom"
import dpoImage from "../../assets/imgs/footer/DPO.png"

export default function Footer() {
  const location = useLocation()
  const isBookingPage = location.pathname === "/booking"
  const isHomePage = location.pathname === "/home"
  const currentYear = new Date().getFullYear()

  return (
    <Box
      sx={{
        bgcolor: "background.footer",
        color: "white",
        py: { xs: 4, md: 6 },
        mb: { xs: isBookingPage || isHomePage ? 0 : 25, md: 0 },
      }}
    >
      <Container
        maxWidth="lg"
        disableGutters
        sx={{
          px: { xs: 2, sm: 3, md: 3 },
          pr: { xs: 2, sm: 3, md: "231px" },
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: { xs: 3, md: 0 },
            pt: { xs: 1, md: 2 },
          }}
        >
          <Box sx={{ minWidth: { xs: "100%", md: "auto" } }}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: { xs: "18px", md: "20px" },
                mb: 1,
              }}
            >
              PrymeBooking
            </Typography>

            <Typography
              sx={{ fontWeight: 400, fontSize: { xs: "16px", md: "18px" } }}
            >
              Powered by TechPryme
            </Typography>
          </Box>

          <Box sx={{ minWidth: { xs: "100%", md: "auto" } }}>
            <Stack
              spacing={1}
              direction="column"
              sx={{ alignItems: { xs: "flex-start", md: "flex-start" } }}
            >
              {menuItems
                .filter((item) => item.label !== "List Your Venue") // TODO: Hiding the list your Venue for now
                .map((item) => (
                  <MuiLink
                    key={item.label}
                    component={NavLink}
                    to={item.href}
                    underline="none"
                    sx={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: { xs: "14px", md: "16px" },
                    }}
                  >
                    {item.label}
                  </MuiLink>
                ))}
            </Stack>
          </Box>

          <Box sx={{ minWidth: { xs: "100%", md: "auto" } }}>
            <Stack
              spacing={1}
              direction="column"
              sx={{ alignItems: { xs: "flex-start", md: "flex-start" } }}
            >
              <MuiLink
                component={NavLink}
                to="/terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
                underline="none"
                sx={{
                  color: "white",
                  fontWeight: 500,
                  fontSize: { xs: "14px", md: "16px" },
                }}
              >
                Terms and Conditions
              </MuiLink>

              <MuiLink
                component={NavLink}
                to="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                underline="none"
                sx={{
                  color: "white",
                  fontWeight: 500,
                  fontSize: { xs: "14px", md: "16px" },
                }}
              >
                Privacy Policy
              </MuiLink>
            </Stack>
          </Box>
        </Box>

        <Divider sx={{ my: 2, bgcolor: "#534181" }} />

        <Typography
          sx={{ fontWeight: 400, fontSize: { xs: "14px", md: "16px" } }}
        >
          {`© ${currentYear} TechPryme Philippines. All rights reserved.`}
        </Typography>

        <Box
          sx={{
            position: "absolute",
            right: { xs: 0, md: 0 },
            top: { xs: -13, md: -13 },
            width: { xs: "65px", md: "85px" },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={dpoImage}
            alt="DPO Registered"
            sx={{
              width: { xs: "65px", md: "80px" },
              height: "auto",
              objectFit: "contain",
            }}
          />

          <Typography
            sx={{
              color: "#ffffff",
              fontSize: { xs: "7px", md: "10px" },
              fontWeight: 400,
              lineHeight: 1.2,
              textAlign: "center",
              whiteSpace: "nowrap",
              mt: { xs: "-2px", md: "-1px" },
            }}
          >
            <Box
              component="span"
              sx={{
                display: "block",
                color: "#e84b91",
                fontWeight: 600,
              }}
            >
              NPC Registration
            </Box>
            No.PIC-008-062-2026
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}
